module.exports = __webpack_public_path__ + "static/media/dove_text.f823579e.svg";